module.exports = __webpack_public_path__ + "cert-variable.50d8d43bcdb6387bde065f4a16e3a29f.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/layout/cert-variable.png
// module id = 8084642016805325
// module chunks = 1